import { env } from './env';

export const properties = {
    VENDOR_ID: "1",
    PASSWORD: "test@123",
    HTTP_METHOD: "HTTP",
    SOAP_METHOD: "SOAP",
    DESCRIPTION: "Test Harness Description",
    ALLOW_AVS_FAIL: "Y",
    ALLOW_CSC_FAIL: "Y",
    REGIONS: {
        AU: "Asia Pacific",
        "EMEA-01": "EMEA-01",
        "EMEA-02": "EMEA-02",
        NA: "North America",
        "NA-03":"North America 03",
        US: "United States",
        CA: "Canada",
        EMEA: "EMEA",
        SG: "Singapore",
        BAD: "Bad Region",
        NoR: "No Region",

    },
    SEL_REGION: "NA",
    OPERATIONS: {
        auth: "WPG_auth",
        authsettle: "WPG_authsettle",
        tokenauth: "WPG_tokenauth",
        tokenauthsettle: "WPG_tokenauthsettle",
        tokenise: "WPG_tokenise",
        tokensettle: "WPG_tokensettle",
        validate: "WPG_validate",
        probe: "WPG_probe",
        tokenrufund: "WPG_tokenrefund",
        voidAuthorise: "WPS_voidAuthorise"
    },
    CURRENCY: "USD",
    VALUE: "12.99",
    ADDRESS: "",
    POST_CODE: "",
    COUNTRY_CODE: "",
    MODE: "199",
    TYPE: "",
    USER_ID: "",
    CUSTOMER_PRESENT: "N",
    TOKEN: "",
    PEDIP: "",
    AUTHCODE: "",
    CUSTOMER_ID: "",
    SECURITY_CHECK_PASS: "PASS",
    SECURITY_CHECK_FAIL: "FAIL",
    WPG_CUSTOM_variables: {
        WPG_CUSTOM_BASKET_tax: "0.00",
        WPG_CUSTOM_GRAPHICSTANDARDS_LINK: "",
        WPG_CUSTOM_adobe_analytics_script_url: "//assets.adobedtm.com/59640f9fa510/c4d79e5b7f7a/launch-7f11993c0de7-development.js",
        WPG_CUSTOM_WILEY_LINK: "",
        WPG_CUSTOM_CURRENT_YEAR: new Date().getFullYear(),
        WPG_CUSTOM_BASKET_currency_symbol: "$",
        WPG_CUSTOM_BASKET_discount: "0.00",
        WPG_CUSTOM_back_url: env.REACT_APP_BACK_URL,
        WPG_CUSTOM_site_url: "",
        WPG_CUSTOM_BASKET_SHIPPING: "10.00"
    },
    RESPONSE_STATUS_MESSAGE: {
        400: ", Bad request!",
        404: ", Page not found!",
        405: ", Method not allowed!",
        408: ", Request time out!",
        502: ", Bad gateway!",
        504: ", Gateway time out!",
    },
    SOAP_REQUEST_PREFIX: "<SOAP-ENV:Envelope xmlns:SOAP-ENV=\"http://schemas.xmlsoap.org/soap/envelope/\" xmlns:ns1=\"tns:wpg\"> <SOAP-ENV:Header/> <SOAP-ENV:Body>",
    SOAP_REQUEST_SUFFIX: "</SOAP-ENV:Body> </SOAP-ENV:Envelope>",
    WPS_OFFLINE_MESSAGE: "OFFLINE",
    DPA_FIELD_MAPPING: {
        "dpaPaymentCardType": "ADPACTYPE",
        "dpaPaymentCardExpirationMonth": "ADPAEXMNTH",
        "dpaPaymentCardExpirationYear": "ADPAEXYEAR",
        "dpaPaymentCardMaskedNumber": "ADPAMASKNM",
        "dpaToken": "ADPATOKEN",
        "dpaChargeId": "ADPACHRGID",
        "dpaAuthorizationId": "ADPAAUTHID",
        "merchantReference": "AREFMERCH",
    },
    md5_digest: {
        validate: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "merchantResponse", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "token", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp"],
        tokenise: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "merchantResponse", "merchantID", "token", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp"],
        authsettle: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "token", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp", "authorizationId", "payerEmail", "payerStatus", "protectionEligibility"],
        auth: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "token", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp", "authorizationId", "payerEmail", "payerStatus", "protectionEligibility"],
        tokenauth: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp"],
        tokenauthsettle: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp"],
        tokenrefund: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp"],
        tokensettle: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp"],
        voidAuthorise: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp"]
    },
    output_params: {
        validate: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "merchantResponse", "merchantReference", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "token", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp", "dpaPaymentCardType", "dpaPaymentCardExpirationMonth", "dpaPaymentCardExpirationYear", "dpaPaymentCardMaskedNumber", "dpaToken", "paymentMethodId"],
        tokenise: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "merchantResponse", "merchantReference", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "token", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp", "dpaPaymentCardType", "dpaPaymentCardExpirationMonth", "dpaPaymentCardExpirationYear", "dpaPaymentCardMaskedNumber", "dpaToken", "paymentMethodId"],
        authsettle: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantReference", "merchantResponse", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "token", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp", "paymentMethodId", "dpaChargeId", "authorizationId", "payerEmail", "payerStatus", "protectionEligibility"],
        auth: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantReference", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "token", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp", "dpaPaymentCardType", "dpaPaymentCardExpirationMonth", "dpaPaymentCardExpirationYear", "dpaPaymentCardMaskedNumber", "dpaToken", "paymentMethodId", "dpaAuthorizationId", "authorizationId", "payerEmail", "payerStatus", "protectionEligibility"],
        tokenauth: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantReference", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp", "dpaToken", "paymentMethodId", "dpaAuthorizationId", "dpaPaymentCardType", "dpaPaymentCardExpirationMonth", "dpaPaymentCardExpirationYear", "dpaPaymentCardMaskedNumber"],
        tokenauthsettle: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantReference", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp", "accountHolderType", "last4", "routingNumber", "mandate", "bsbNumber", "dpaToken", "paymentMethodId", "dpaPaymentCardType", "dpaPaymentCardExpirationMonth", "dpaPaymentCardExpirationYear", "dpaPaymentCardMaskedNumber", "dpaChargeId"],
        tokenrefund: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantReference", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp"],
        tokensettle: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantReference", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp", "dpaToken","dpaPaymentCardType", "dpaPaymentCardExpirationMonth", "dpaPaymentCardExpirationYear", "dpaPaymentCardMaskedNumber", "paymentMethodId", "dpaChargeId"],
        voidAuthorise: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantReference", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskedCardNumber", "cardExpiry", "timestamp"]
    },
    output_params_soap: {
        WPG_probe: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "userID", "accessToken", "timestamp"],
        WPG_tokenauth: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantReference", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskCardNumber",  "maskedCardNumber", "cardExpiry", "timestamp"],
        WPG_tokensettle: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantReference", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "authTransID", "acquirerID", "acquirerName", "bankID", "bankName", "maskCardNumber", "maskedCardNumber",  "cardExpiry", "timestamp"],
        WPG_tokenauthsettle: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantReference", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskCardNumber", "maskedCardNumber",  "cardExpiry", "timestamp", "accountHolderType", "last4", "routingNumber", "mandate", "bsbNumber"],
        WPG_tokenrefund: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantReference", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskCardNumber", "maskedCardNumber",  "cardExpiry", "timestamp", "security"],
        WPS_voidAuthorise: ["operation", "returnCode", "returnMessage", "vendorID", "transID", "value", "currency", "merchantResponse", "merchantReference", "merchantID", "CSCResult", "AVSAddrResult", "AVSPostResult", "authCode", "acquirerID", "acquirerName", "bankID", "bankName", "maskCardNumber", "maskedCardNumber",  "cardExpiry", "timestamp"]
    },
    HTTP_RESPONSE_TITLE: {
        validate: "Validate Response",
        tokenise: "Tokenise Response",
        authsettle: "Authorise & Settle Response",
        auth: "Authorise Response",
        tokenauth: "Token Authorise Response",
        tokenrefund: "Token Refund Response",
        tokenauthsettle: "Token Authorise & Settle Response",
        tokensettle: "Token Settle Response",
        voidAuthorise: "Void Authorise Response"
    },
    INTERAVTIVE_OPERATIONS: ["tokenise", "validate", "auth", "authsettle"],
    RESPONSE_APP_ID_FIELDNAME: "vendorID",
    NEW_RESPONSE_APP_ID_FIELDNAME: "Client Application ID",
    paymentMethodList: [
        { id: "CardPayment", title: "Card Payment", options: [{ id: "Debit/Credit Card", title: "Debit/Credit Card", value: "Card" }] },
        { id: "Wallet", title: "Wallet", options: [{ id: "GooglePay", title: "GooglePay", value: "GooglePay" }, { id: "ApplePay", title: "ApplePay", value: "ApplePay" }, { id: "PayPal", title: "PayPal", value: "PayPal" }] },
        { id: "BankDebits", title: "Bank Debits", options: [{ id: "ACH", title: "ACH", value: "ACH" },{ id: "BACS", title: "BACS", value: "BACS" }, { id: "BECS", title: "BECS", value: "BECS" }] }
    ],
    INTENTTYPE: {
        AUTHORIZE: "AUTHORIZE",
        AUTHORIZE_CAPTURE: "AUTHORIZE_CAPTURE",
        SUBSCRIPTION: "SUBSCRIPTION",
        SAVE_CARD: "SAVE_CARD"
    },
    OPERATION_NAME_MAPPING: {
        auth: "AUTHORISED",
        authsettle: "PAID",
        tokenise: "TOKENISED",
        validate: "VALIDATED"
    },
    LOCALE: {
        "": "None",
        ar: "Arabic",
        bg: "Bulgarian (Bulgaria)",
        cs: "Czech (Czech Republic)",
        da: "Danish (Denmark)",
        de: "German (Germany)",
        el: "Greek (Greece)",
        en: "English",
        "en-GB": "English (United Kingdom)",
        es: "Spanish (Spain)",
        "es-419": "Spanish (Latin America)",
        et: "Estonian (Estonia)",
        fi: "Finnish (Finland)",
        fil: "Filipino (Philipines)",
        fr: "French (France)",
        "fr-CA": "French (Canada)",
        he: "Hebrew (Israel)",
        hr: "Croatian (Croatia)",
        hu: "Hungarian (Hungary)",
        id: "Indonesian (Indonesia)",
        it: "Italian (Italy)",
        ja: "Japanese (Japan)",
        ko: "Korean (Korea)",
        lt: "Lithuanian (Lithuania)",
        lv: "Latvian (Latvia)",
        ms: "Malay (Malaysia)",
        mt: "Maltese (Malta)",
        nb: "Norwegian Bokmål",
        nl: "Dutch (Netherlands)",
        pl: "Polish (Poland)",
        "pt-BR": "Portuguese (Brazil)",
        pt: "Portuguese (Brazil)",
        ro: "Romanian (Romania)",
        ru: "Russian (Russia)",
        sk: "Slovak (Slovakia)",
        sl: "Slovenian (Slovenia)",
        sv: "Swedish (Sweden)",
        th: "Thai (Thailand)",
        tr: "Turkish (Turkey)",
        vi: "Vietnamese (Vietnam)",
        zh: "Chinese Simplified (China)",
        "zh-HK": "Chinese Traditional (Hong Kong)",
        "zh-TW": "Chinese Traditional (Taiwan)"
    },
    SEL_LOCALE: "",
    CreditCardProvider: "Card",
    ACHProvider: "ACH",
    BacsProvider: "BACS",
    BecsProvider: "BECS",
    PayPalProvider: "PayPal",
    WalletProvider: "Wallet",
    ExpressElementProvider: "ExpressElement",
    PAYPAL_FAKE_NONCE: [
        { value: "fake-paypal-one-time-nonce", description: "Only valid when using the mocked PayPal testing strategy. A nonce representing an unvaulted PayPal account that a customer has authorized for one-time payments via the Checkout flow. Learn more about PayPal testing options." },
        { value: "fake-paypal-billing-agreement-nonce", description: "Only valid when using the mocked PayPal testing strategy. A nonce representing a PayPal billing agreement that a customer has authorized via the Vault flow. Learn more about PayPal testing options." },
        { value: "fake-luhn-invalid-nonce", description: "A nonce representing a Luhn-invalid card" }
    ],
    SEL_PAYPAL_FAKE_NONCE: "fake-paypal-one-time-nonce",
    CAPTCHA_SITE_KEY: [
        { value: "1x00000000000000000000AA", description: "Always passes - visible" },
        { value: "2x00000000000000000000AB", description: "Always blocks - visible" },
        { value: "1x00000000000000000000BB", description: "Always passes - invisible" },
        { value: "2x00000000000000000000BB", description: "Always blocks - invisible" },
        { value: "3x00000000000000000000FF", description: "Forces an interactive challenge - visible" }
    ],
    SEL_CAPTCHA_SITE_KEY: "1x00000000000000000000AA",
    CAPTCHA_TEST_DESCRIPTION: [
        { value: "always_passes", description: "Always passes" },
        { value: "always_fails", description: "Always fails" },
        { value: "token_already_spent", description: "Yields a “token already spent error" }
    ],
    SEL_CAPTCHA_TEST_DESCRIPTION: "always_passes",
    COUNTRY_LIST: [
        { name: "SELECT", code: "" },
        { name: "Afghanistan", code: "AF" },
        { name: "Åland Islands", code: "AX" },
        { name: "Albania", code: "AL" },
        { name: "Algeria", code: "DZ" },
        { name: "American Samoa", code: "AS" },
        { name: "Andorra", code: "AD" },
        { name: "Angola", code: "AO" },
        { name: "Anguilla", code: "AI" },
        { name: "Antarctica", code: "AQ" },
        { name: "Antigua & Barbuda", code: "AG" },
        { name: "Argentina", code: "AR" },
        { name: "Armenia", code: "AM" },
        { name: "Aruba", code: "AW" },
        { name: "Australia", code: "AU" },
        { name: "Austria", code: "AT" },
        { name: "Azerbaijan", code: "AZ" },
        { name: "Bahamas", code: "BS" },
        { name: "Bahrain", code: "BH" },
        { name: "Bangladesh", code: "BD" },
        { name: "Barbados", code: "BB" },
        { name: "Belarus", code: "BY" },
        { name: "Belgium", code: "BE" },
        { name: "Belize", code: "BZ" },
        { name: "Benin", code: "BJ" },
        { name: "Bermuda", code: "BM" },
        { name: "Bhutan", code: "BT" },
        { name: "Bolivia", code: "BO" },
        { name: "Caribbean Netherlands", code: "BQ" },
        { name: "Bosnia & Herzegovina", code: "BA" },
        { name: "Botswana", code: "BW" },
        { name: "Bouvet Island", code: "BV" },
        { name: "Brazil", code: "BR" },
        { name: "British Indian Ocean Territory", code: "IO" },
        { name: "Brunei", code: "BN" },
        { name: "Bulgaria", code: "BG" },
        { name: "Burkina Faso", code: "BF" },
        { name: "Burundi", code: "BI" },
        { name: "Cambodia", code: "KH" },
        { name: "Cameroon", code: "CM" },
        { name: "Canada", code: "CA" },
        { name: "Cape Verde", code: "CV" },
        { name: "Cayman Islands", code: "KY" },
        { name: "Central African Republic", code: "CF" },
        { name: "Chad", code: "TD" },
        { name: "Chile", code: "CL" },
        { name: "China", code: "CN" },
        { name: "Christmas Island", code: "CX" },
        { name: "Cocos (Keeling) Islands", code: "CC" },
        { name: "Colombia", code: "CO" },
        { name: "Comoros", code: "KM" },
        { name: "Congo - Brazzaville", code: "CG" },
        { name: "Congo - Kinshasa", code: "CD" },
        { name: "Cook Islands", code: "CK" },
        { name: "Costa Rica", code: "CR" },
        { name: "Côte d’Ivoire", code: "CI" },
        { name: "Croatia", code: "HR" },
        { name: "Cuba", code: "CU" },
        { name: "Curaçao", code: "CW" },
        { name: "Cyprus", code: "CY" },
        { name: "Czechia", code: "CZ" },
        { name: "Denmark", code: "DK" },
        { name: "Djibouti", code: "DJ" },
        { name: "Dominica", code: "DM" },
        { name: "Dominican Republic", code: "DO" },
        { name: "Ecuador", code: "EC" },
        { name: "Egypt", code: "EG" },
        { name: "El Salvador", code: "SV" },
        { name: "Equatorial Guinea", code: "GQ" },
        { name: "Eritrea", code: "ER" },
        { name: "Estonia", code: "EE" },
        { name: "Ethiopia", code: "ET" },
        { name: "Falkland Islands (Islas Malvinas)", code: "FK" },
        { name: "Faroe Islands", code: "FO" },
        { name: "Fiji", code: "FJ" },
        { name: "Finland", code: "FI" },
        { name: "France", code: "FR" },
        { name: "French Guiana", code: "GF" },
        { name: "French Polynesia", code: "PF" },
        { name: "French Southern Territories", code: "TF" },
        { name: "Gabon", code: "GA" },
        { name: "Gambia", code: "GM" },
        { name: "Georgia", code: "GE" },
        { name: "Germany", code: "DE" },
        { name: "Ghana", code: "GH" },
        { name: "Gibraltar", code: "GI" },
        { name: "Greece", code: "GR" },
        { name: "Greenland", code: "GL" },
        { name: "Grenada", code: "GD" },
        { name: "Guadeloupe", code: "GP" },
        { name: "Guam", code: "GU" },
        { name: "Guatemala", code: "GT" },
        { name: "Guernsey", code: "GG" },
        { name: "Guinea", code: "GN" },
        { name: "Guinea-Bissau", code: "GW" },
        { name: "Guyana", code: "GY" },
        { name: "Haiti", code: "HT" },
        { name: "Heard & McDonald Islands", code: "HM" },
        { name: "Vatican City", code: "VA" },
        { name: "Honduras", code: "HN" },
        { name: "Hong Kong", code: "HK" },
        { name: "Hungary", code: "HU" },
        { name: "Iceland", code: "IS" },
        { name: "India", code: "IN" },
        { name: "Indonesia", code: "ID" },
        { name: "Iran", code: "IR" },
        { name: "Iraq", code: "IQ" },
        { name: "Ireland", code: "IE" },
        { name: "Isle of Man", code: "IM" },
        { name: "Israel", code: "IL" },
        { name: "Italy", code: "IT" },
        { name: "Jamaica", code: "JM" },
        { name: "Japan", code: "JP" },
        { name: "Jersey", code: "JE" },
        { name: "Jordan", code: "JO" },
        { name: "Kazakhstan", code: "KZ" },
        { name: "Kenya", code: "KE" },
        { name: "Kiribati", code: "KI" },
        { name: "North Korea", code: "KP" },
        { name: "South Korea", code: "KR" },
        { name: "Kosovo", code: "XK" },
        { name: "Kuwait", code: "KW" },
        { name: "Kyrgyzstan", code: "KG" },
        { name: "Laos", code: "LA" },
        { name: "Latvia", code: "LV" },
        { name: "Lebanon", code: "LB" },
        { name: "Lesotho", code: "LS" },
        { name: "Liberia", code: "LR" },
        { name: "Libya", code: "LY" },
        { name: "Liechtenstein", code: "LI" },
        { name: "Lithuania", code: "LT" },
        { name: "Luxembourg", code: "LU" },
        { name: "Macao", code: "MO" },
        { name: "North Macedonia", code: "MK" },
        { name: "Madagascar", code: "MG" },
        { name: "Malawi", code: "MW" },
        { name: "Malaysia", code: "MY" },
        { name: "Maldives", code: "MV" },
        { name: "Mali", code: "ML" },
        { name: "Malta", code: "MT" },
        { name: "Marshall Islands", code: "MH" },
        { name: "Martinique", code: "MQ" },
        { name: "Mauritania", code: "MR" },
        { name: "Mauritius", code: "MU" },
        { name: "Mayotte", code: "YT" },
        { name: "Mexico", code: "MX" },
        { name: "Micronesia", code: "FM" },
        { name: "Moldova", code: "MD" },
        { name: "Monaco", code: "MC" },
        { name: "Mongolia", code: "MN" },
        { name: "Montenegro", code: "ME" },
        { name: "Montserrat", code: "MS" },
        { name: "Morocco", code: "MA" },
        { name: "Mozambique", code: "MZ" },
        { name: "Myanmar (Burma)", code: "MM" },
        { name: "Namibia", code: "NA" },
        { name: "Nauru", code: "NR" },
        { name: "Nepal", code: "NP" },
        { name: "Netherlands", code: "NL" },
        { name: "Curaçao", code: "AN" },
        { name: "New Caledonia", code: "NC" },
        { name: "New Zealand", code: "NZ" },
        { name: "Nicaragua", code: "NI" },
        { name: "Niger", code: "NE" },
        { name: "Nigeria", code: "NG" },
        { name: "Niue", code: "NU" },
        { name: "Norfolk Island", code: "NF" },
        { name: "Northern Mariana Islands", code: "MP" },
        { name: "Norway", code: "NO" },
        { name: "Oman", code: "OM" },
        { name: "Pakistan", code: "PK" },
        { name: "Palau", code: "PW" },
        { name: "Palestine", code: "PS" },
        { name: "Panama", code: "PA" },
        { name: "Papua New Guinea", code: "PG" },
        { name: "Paraguay", code: "PY" },
        { name: "Peru", code: "PE" },
        { name: "Philippines", code: "PH" },
        { name: "Pitcairn Islands", code: "PN" },
        { name: "Poland", code: "PL" },
        { name: "Portugal", code: "PT" },
        { name: "Puerto Rico", code: "PR" },
        { name: "Qatar", code: "QA" },
        { name: "Réunion", code: "RE" },
        { name: "Romania", code: "RO" },
        { name: "Russia", code: "RU" },
        { name: "Rwanda", code: "RW" },
        { name: "St. Barthélemy", code: "BL" },
        { name: "St. Helena", code: "SH" },
        { name: "St. Kitts & Nevis", code: "KN" },
        { name: "St. Lucia", code: "LC" },
        { name: "St. Martin", code: "MF" },
        { name: "St. Pierre & Miquelon", code: "PM" },
        { name: "St. Vincent & Grenadines", code: "VC" },
        { name: "Samoa", code: "WS" },
        { name: "San Marino", code: "SM" },
        { name: "São Tomé & Príncipe", code: "ST" },
        { name: "Saudi Arabia", code: "SA" },
        { name: "Senegal", code: "SN" },
        { name: "Serbia", code: "RS" },
        { name: "Serbia", code: "CS" },
        { name: "Seychelles", code: "SC" },
        { name: "Sierra Leone", code: "SL" },
        { name: "Singapore", code: "SG" },
        { name: "Sint Maarten", code: "SX" },
        { name: "Slovakia", code: "SK" },
        { name: "Slovenia", code: "SI" },
        { name: "Solomon Islands", code: "SB" },
        { name: "Somalia", code: "SO" },
        { name: "South Africa", code: "ZA" },
        { name: "South Georgia & South Sandwich Islands", code: "GS" },
        { name: "South Sudan", code: "SS" },
        { name: "Spain", code: "ES" },
        { name: "Sri Lanka", code: "LK" },
        { name: "Sudan", code: "SD" },
        { name: "Suriname", code: "SR" },
        { name: "Svalbard & Jan Mayen", code: "SJ" },
        { name: "Eswatini", code: "SZ" },
        { name: "Sweden", code: "SE" },
        { name: "Switzerland", code: "CH" },
        { name: "Syria", code: "SY" },
        { name: "Taiwan", code: "TW" },
        { name: "Tajikistan", code: "TJ" },
        { name: "Tanzania", code: "TZ" },
        { name: "Thailand", code: "TH" },
        { name: "Timor-Leste", code: "TL" },
        { name: "Togo", code: "TG" },
        { name: "Tokelau", code: "TK" },
        { name: "Tonga", code: "TO" },
        { name: "Trinidad & Tobago", code: "TT" },
        { name: "Tunisia", code: "TN" },
        { name: "Turkey", code: "TR" },
        { name: "Turkmenistan", code: "TM" },
        { name: "Turks & Caicos Islands", code: "TC" },
        { name: "Tuvalu", code: "TV" },
        { name: "Uganda", code: "UG" },
        { name: "Ukraine", code: "UA" },
        { name: "United Arab Emirates", code: "AE" },
        { name: "United Kingdom", code: "GB" },
        { name: "United States", code: "US" },
        { name: "U.S. Outlying Islands", code: "UM" },
        { name: "Uruguay", code: "UY" },
        { name: "Uzbekistan", code: "UZ" },
        { name: "Vanuatu", code: "VU" },
        { name: "Venezuela", code: "VE" },
        { name: "Vietnam", code: "VN" },
        { name: "British Virgin Islands", code: "VG" },
        { name: "U.S. Virgin Islands", code: "VI" },
        { name: "Wallis & Futuna", code: "WF" },
        { name: "Western Sahara", code: "EH" },
        { name: "Yemen", code: "YE" },
        { name: "Zambia", code: "ZM" },
        { name: "Zimbabwe", code: "ZW" }
    ]
}
